import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { DsFieldsFragmentDoc } from '../../graphql/gql-fragments/document-signature.graphql';
import { IdentityFieldsFragmentDoc } from '../../graphql/gql-fragments/identity.graphql';
import { FileFieldsFragmentDoc } from '../../graphql/gql-fragments/document.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlDocumentSignaturesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  fileId: Types.Scalars['ID']['input'];
}>;


export type GqlDocumentSignaturesQuery = { documentSignatures: Array<{ id: string, signed: boolean, headerPrimaryLang?: string | null, headerSecondaryLang?: string | null, authMethodToView?: Types.GqlScriveAuthMethod | null, authMethodToSign?: Types.GqlScriveAuthMethod | null, deliveryMethod?: string | null, email?: string | null, fileId: string, signatoryId: string, proxyId?: string | null, scriveSignTime?: string | null, scriveSeenTime?: string | null, scriveRejectedTime?: string | null, scriveRejectionReason?: string | null, scriveReadInvitationTime?: string | null, scriveEmailDeliveryStatus?: string | null, zignedParticipantStatus?: Types.GqlZignedParticipantStatus | null, zignedParticipantRole?: Types.GqlZignedParticipantRole | null, zignedParticipantSigningRoomLink?: string | null, createdAt: string, updatedAt: string, signatory: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, proxy?: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } | null }> };

export type GqlSetSignAuthMethodMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlDsSetAuthMethodToSignInput;
}>;


export type GqlSetSignAuthMethodMutation = { dsSetAuthMethodToSign: { id: string, signed: boolean, headerPrimaryLang?: string | null, headerSecondaryLang?: string | null, authMethodToView?: Types.GqlScriveAuthMethod | null, authMethodToSign?: Types.GqlScriveAuthMethod | null, deliveryMethod?: string | null, email?: string | null, fileId: string, signatoryId: string, proxyId?: string | null, scriveSignTime?: string | null, scriveSeenTime?: string | null, scriveRejectedTime?: string | null, scriveRejectionReason?: string | null, scriveReadInvitationTime?: string | null, scriveEmailDeliveryStatus?: string | null, zignedParticipantStatus?: Types.GqlZignedParticipantStatus | null, zignedParticipantRole?: Types.GqlZignedParticipantRole | null, zignedParticipantSigningRoomLink?: string | null, createdAt: string, updatedAt: string } };

export type GqlCreateDocumentSignatureMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  input: Types.GqlDsCreateInput;
}>;


export type GqlCreateDocumentSignatureMutation = { createDocumentSignature: { id: string, signed: boolean, headerPrimaryLang?: string | null, headerSecondaryLang?: string | null, authMethodToView?: Types.GqlScriveAuthMethod | null, authMethodToSign?: Types.GqlScriveAuthMethod | null, deliveryMethod?: string | null, email?: string | null, fileId: string, signatoryId: string, proxyId?: string | null, scriveSignTime?: string | null, scriveSeenTime?: string | null, scriveRejectedTime?: string | null, scriveRejectionReason?: string | null, scriveReadInvitationTime?: string | null, scriveEmailDeliveryStatus?: string | null, zignedParticipantStatus?: Types.GqlZignedParticipantStatus | null, zignedParticipantRole?: Types.GqlZignedParticipantRole | null, zignedParticipantSigningRoomLink?: string | null, createdAt: string, updatedAt: string, signatory: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, proxy?: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } | null } };

export type GqlDeleteDocumentSignatureMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlDeleteDocumentSignatureMutation = { deleteDocumentSignature: { id: string } };

export type GqlFileSignRefreshMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GqlFileSignRefreshMutation = { fileSignRefresh: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean, documentSignatures: Array<{ id: string, signed: boolean, headerPrimaryLang?: string | null, headerSecondaryLang?: string | null, authMethodToView?: Types.GqlScriveAuthMethod | null, authMethodToSign?: Types.GqlScriveAuthMethod | null, deliveryMethod?: string | null, email?: string | null, fileId: string, signatoryId: string, proxyId?: string | null, scriveSignTime?: string | null, scriveSeenTime?: string | null, scriveRejectedTime?: string | null, scriveRejectionReason?: string | null, scriveReadInvitationTime?: string | null, scriveEmailDeliveryStatus?: string | null, zignedParticipantStatus?: Types.GqlZignedParticipantStatus | null, zignedParticipantRole?: Types.GqlZignedParticipantRole | null, zignedParticipantSigningRoomLink?: string | null, createdAt: string, updatedAt: string, signatory: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string }, proxy?: { id: string, identityNumberKind: number, identityNumber: string, juridicalKind: number, name: string, email?: string | null, emailMd5?: string | null, phone?: string | null, countryCode?: string | null, address?: string | null, userId?: string | null, isSwedish: boolean, createdAt: string, updatedAt: string, companyId: string } | null }> } };


export const DocumentSignaturesDocument = gql`
    query DocumentSignatures($companyId: ID!, $fileId: ID!) {
  documentSignatures(companyId: $companyId, fileId: $fileId) {
    ...DsFields
    signatory {
      ...IdentityFields
    }
    proxy {
      ...IdentityFields
    }
  }
}
    ${DsFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;

/**
 * __useDocumentSignaturesQuery__
 *
 * To run a query within a React component, call `useDocumentSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSignaturesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDocumentSignaturesQuery(baseOptions: Apollo.QueryHookOptions<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables> & ({ variables: GqlDocumentSignaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables>(DocumentSignaturesDocument, options);
      }
export function useDocumentSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables>(DocumentSignaturesDocument, options);
        }
export function useDocumentSignaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables>(DocumentSignaturesDocument, options);
        }
export type DocumentSignaturesQueryHookResult = ReturnType<typeof useDocumentSignaturesQuery>;
export type DocumentSignaturesLazyQueryHookResult = ReturnType<typeof useDocumentSignaturesLazyQuery>;
export type DocumentSignaturesSuspenseQueryHookResult = ReturnType<typeof useDocumentSignaturesSuspenseQuery>;
export type DocumentSignaturesQueryResult = Apollo.QueryResult<GqlDocumentSignaturesQuery, GqlDocumentSignaturesQueryVariables>;
export const SetSignAuthMethodDocument = gql`
    mutation SetSignAuthMethod($companyId: ID!, $input: DsSetAuthMethodToSignInput!) {
  dsSetAuthMethodToSign(companyId: $companyId, input: $input) {
    ...DsFields
  }
}
    ${DsFieldsFragmentDoc}`;
export type GqlSetSignAuthMethodMutationFn = Apollo.MutationFunction<GqlSetSignAuthMethodMutation, GqlSetSignAuthMethodMutationVariables>;

/**
 * __useSetSignAuthMethodMutation__
 *
 * To run a mutation, you first call `useSetSignAuthMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSignAuthMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSignAuthMethodMutation, { data, loading, error }] = useSetSignAuthMethodMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSignAuthMethodMutation(baseOptions?: Apollo.MutationHookOptions<GqlSetSignAuthMethodMutation, GqlSetSignAuthMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlSetSignAuthMethodMutation, GqlSetSignAuthMethodMutationVariables>(SetSignAuthMethodDocument, options);
      }
export type SetSignAuthMethodMutationHookResult = ReturnType<typeof useSetSignAuthMethodMutation>;
export type SetSignAuthMethodMutationResult = Apollo.MutationResult<GqlSetSignAuthMethodMutation>;
export type SetSignAuthMethodMutationOptions = Apollo.BaseMutationOptions<GqlSetSignAuthMethodMutation, GqlSetSignAuthMethodMutationVariables>;
export const CreateDocumentSignatureDocument = gql`
    mutation CreateDocumentSignature($companyId: ID!, $input: DsCreateInput!) {
  createDocumentSignature(companyId: $companyId, input: $input) {
    ...DsFields
    signatory {
      ...IdentityFields
    }
    proxy {
      ...IdentityFields
    }
  }
}
    ${DsFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;
export type GqlCreateDocumentSignatureMutationFn = Apollo.MutationFunction<GqlCreateDocumentSignatureMutation, GqlCreateDocumentSignatureMutationVariables>;

/**
 * __useCreateDocumentSignatureMutation__
 *
 * To run a mutation, you first call `useCreateDocumentSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentSignatureMutation, { data, loading, error }] = useCreateDocumentSignatureMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentSignatureMutation(baseOptions?: Apollo.MutationHookOptions<GqlCreateDocumentSignatureMutation, GqlCreateDocumentSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlCreateDocumentSignatureMutation, GqlCreateDocumentSignatureMutationVariables>(CreateDocumentSignatureDocument, options);
      }
export type CreateDocumentSignatureMutationHookResult = ReturnType<typeof useCreateDocumentSignatureMutation>;
export type CreateDocumentSignatureMutationResult = Apollo.MutationResult<GqlCreateDocumentSignatureMutation>;
export type CreateDocumentSignatureMutationOptions = Apollo.BaseMutationOptions<GqlCreateDocumentSignatureMutation, GqlCreateDocumentSignatureMutationVariables>;
export const DeleteDocumentSignatureDocument = gql`
    mutation DeleteDocumentSignature($companyId: ID!, $id: ID!) {
  deleteDocumentSignature(companyId: $companyId, id: $id) {
    id
  }
}
    `;
export type GqlDeleteDocumentSignatureMutationFn = Apollo.MutationFunction<GqlDeleteDocumentSignatureMutation, GqlDeleteDocumentSignatureMutationVariables>;

/**
 * __useDeleteDocumentSignatureMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentSignatureMutation, { data, loading, error }] = useDeleteDocumentSignatureMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentSignatureMutation(baseOptions?: Apollo.MutationHookOptions<GqlDeleteDocumentSignatureMutation, GqlDeleteDocumentSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlDeleteDocumentSignatureMutation, GqlDeleteDocumentSignatureMutationVariables>(DeleteDocumentSignatureDocument, options);
      }
export type DeleteDocumentSignatureMutationHookResult = ReturnType<typeof useDeleteDocumentSignatureMutation>;
export type DeleteDocumentSignatureMutationResult = Apollo.MutationResult<GqlDeleteDocumentSignatureMutation>;
export type DeleteDocumentSignatureMutationOptions = Apollo.BaseMutationOptions<GqlDeleteDocumentSignatureMutation, GqlDeleteDocumentSignatureMutationVariables>;
export const FileSignRefreshDocument = gql`
    mutation FileSignRefresh($companyId: ID!, $id: ID!) {
  fileSignRefresh(companyId: $companyId, id: $id) {
    ...FileFields
    documentSignatures {
      ...DsFields
      signatory {
        ...IdentityFields
      }
      proxy {
        ...IdentityFields
      }
    }
  }
}
    ${FileFieldsFragmentDoc}
${DsFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;
export type GqlFileSignRefreshMutationFn = Apollo.MutationFunction<GqlFileSignRefreshMutation, GqlFileSignRefreshMutationVariables>;

/**
 * __useFileSignRefreshMutation__
 *
 * To run a mutation, you first call `useFileSignRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileSignRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileSignRefreshMutation, { data, loading, error }] = useFileSignRefreshMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileSignRefreshMutation(baseOptions?: Apollo.MutationHookOptions<GqlFileSignRefreshMutation, GqlFileSignRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlFileSignRefreshMutation, GqlFileSignRefreshMutationVariables>(FileSignRefreshDocument, options);
      }
export type FileSignRefreshMutationHookResult = ReturnType<typeof useFileSignRefreshMutation>;
export type FileSignRefreshMutationResult = Apollo.MutationResult<GqlFileSignRefreshMutation>;
export type FileSignRefreshMutationOptions = Apollo.BaseMutationOptions<GqlFileSignRefreshMutation, GqlFileSignRefreshMutationVariables>;